// import { getCurrentUser } from 'helpers/Utils';
// import { isAuthGuardActive, currentUser } from 'constants/defaultValues';
import {
  GET_COLLECTIONS,
  GET_COLLECTIONS_ERROR,
  GET_COLLECTIONS_SUCCESS,
  CREATE_COLLECTION,
  CREATE_COLLECTION_ERROR,
  CREATE_COLLECTION_SUCCESS,
  UPDATE_COLLECTION,
  UPDATE_COLLECTION_ERROR,
  UPDATE_COLLECTION_SUCCESS,
  DELETE_COLLECTION,
  DELETE_COLLECTION_ERROR,
  DELETE_COLLECTION_SUCCESS,
  SET_DELETING_COLLECTION,
  SET_EDITING_COLLECTION,
  SET_CREATING_COLLECTION,
  Messages,
  INSPECT_COLLECTION,
} from '../contants';

const INIT_STATE = {
  status: 'init',
  loading: false,
  list: [],
  current: false,
  creating: false, // this can hold {...collection, loading, message:{type:false|string,text:string}}
  editing: false, // this can hold {...collection, loading, message:{type:false|string,text:string}}
  deleting: false, // this can hold {...collection, loading, message:{type:false|string,text:string}}
  message: Messages.empty(),
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_COLLECTIONS: {
      return { ...state, loading: true, message: Messages.empty() };
    }
    case GET_COLLECTIONS_SUCCESS: {
      return {
        ...state,
        loading: false,
        list: action.payload,
        message: Messages.success('collections loaded!'),
        status: 'loaded',
      };
    }
    case GET_COLLECTIONS_ERROR: {
      return {
        ...state,
        loading: false,
        list: [],
        status: 'error',
        message: Messages.error(action.payload),
      };
    }
    case INSPECT_COLLECTION: {
      const current = action.payload;
      return { ...state, current };
    }

    case SET_CREATING_COLLECTION:
      return {
        ...state,
        creating: action.payload,
      };

    case CREATE_COLLECTION: {
      return {
        ...state,
        creating: {
          ...state.creating,
          message: Messages.empty(),
          loading: true,
        },
      };
    }
    case CREATE_COLLECTION_SUCCESS: {
      const colctns = [...state.list];
      colctns.push(action.payload);
      return {
        ...state,
        list: colctns,
        creating: false,
      };
    }
    case CREATE_COLLECTION_ERROR: {
      const { creating } = state;
      return {
        ...state,
        creating: {
          ...creating,
          loading: false,
          message: Messages.error(action.payload),
        },
      };
    }

    case SET_EDITING_COLLECTION:
      return { ...state, editing: action.payload };
    case UPDATE_COLLECTION: {
      const colctns = [...state.list];
      return {
        ...state,
        list: colctns.map((v) => {
          return v.id === action.payload.id
            ? { ...v, loading: true }
            : { ...v };
        }),
        editing: { ...state.editing, message: Messages.empty(), loading: true },
      };
    }
    case UPDATE_COLLECTION_SUCCESS: {
      const colctns = [...state.list];
      return {
        ...state,
        list: colctns.map((v) => {
          return v.id === action.payload.id
            ? { ...v, ...action.payload, loading: false }
            : { ...v };
        }),
        editing: false,
      };
    }
    case UPDATE_COLLECTION_ERROR: {
      const colctns = [...state.list];
      const { editing } = state;
      return {
        ...state,
        list: colctns.map((v) => {
          return v.id === editing.id ? { ...v, loading: false } : { ...v };
        }),
        editing: {
          ...editing,
          loading: false,
          message: Messages.error(action.payload),
        },
      };
    }

    // Deleting

    case SET_DELETING_COLLECTION: {
      return { ...state, deleting: action.payload };
    }
    case DELETE_COLLECTION: {
      const colctns = [...state.list];
      return {
        ...state,
        list: colctns.map((v) => {
          return v.id === action.payload.id
            ? { ...v, loading: true }
            : { ...v };
        }),
        deleting: {
          ...state.deleting,
          message: Messages.empty(),
          loading: true,
        },
      };
    }
    case DELETE_COLLECTION_SUCCESS: {
      const colctns = [...state.list];
      return {
        ...state,
        list: colctns.filter((v) => v.id !== action.payload),
        deleting: false,
      };
    }
    case DELETE_COLLECTION_ERROR: {
      const colctns = [...state.list];
      const { deleting } = state;
      return {
        ...state,
        list: colctns.map((v) => {
          return v.id === deleting.id ? { ...v, loading: false } : { ...v };
        }),
        deleting: {
          ...deleting,
          loading: false,
          message: Messages.error(action.payload),
        },
      };
    }

    default:
      return { ...state };
  }
};
